import { LOCALE_ID, Pipe, PipeTransform, inject } from "@angular/core";

@Pipe({
  standalone: true,
  name: "localizeTime",
})
export class LocalizeTimePipe implements PipeTransform {
  private localeId = inject(LOCALE_ID);

  transform(date: Date): string {
    return date.toLocaleTimeString(this.localeId);
  }
}
